// SHARED

import { Pipe, PipeTransform } from '@angular/core';

const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

  transform(phone: string): string {
    return phone.replace(PHONE_REGEX, '($1) $2-$3');
  }

}
